import {
  List,
  Datagrid,
  TextField,
  ChipField,
  ArrayField,
  SingleFieldList,
  DateField,
} from "react-admin";
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";

export const AnswerList = (props) => (
  <List
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Respostas"
    exporter={exporter}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    actions={<CustomActions />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField sortable={false} label="Usuário (Documento)" source="user.document" />
      <TextField sortable={false} label="Pergunta" source="survey.question" />
      <TextField sortable={false} label="Resposta" source="optionSurvey.value" />
      <ArrayField sortable={false} label="Ciclo" source="survey.cycle">
        <SingleFieldList>
          <ChipField source="id" />
        </SingleFieldList>
      </ArrayField>
      <DateField label="Data de Criação" source="createdAt" />
    </Datagrid>
  </List>
);

export default AnswerList;
